import { useContext } from 'react';
import { AmplitudeContext } from "./AmplitudeContext";
/**
 * @deprecated Amplitude removed — the returned `logEvent` is now a no-op
 * and `amplitude` is always `undefined`. Kept for backwards compatibility;
 * will be deleted in a future release.
 */
function useAmplitude() {
  var context = useContext(AmplitudeContext);
  if (context === undefined) {
    throw new Error('useAmplitude must be used within an AmplitudeProvider');
  }
  return context;
}
export default useAmplitude;